// extracted by mini-css-extract-plugin
module.exports = {"rolesListItem":"Roles_roles-list-item__6vZNS","rolesList":"Roles_roles-list__2XdDk"};